import { getEnvConfig } from '../config';

const CONFIG = getEnvConfig(process.env.NAME);

export const useGetTargetOrigin = () => {
  return CONFIG.TARGET_ORIGIN;
};
